import { defineComponent, type PropType } from 'vue'
import { type CategoryItemTree } from '@/types/book_item'

export const DetailsTree = defineComponent({
  props: {
    item: Object as PropType<CategoryItemTree>
  },

  setup(props) {
    return () => getDetail(props.item!)
  }
})

const getDetail = (tree: CategoryItemTree) => {
  if (tree && tree.children && tree.children.length == 0) {
    return (
      <li>
        <a href={tree.page_url}>{tree.name} </a>
      </li>
    )
  }

  return (
    <details open={false}>
      <summary class={tree.top > 0 ? 'font-bold' : 'font-normal'}>
        <span class={'text-wrap'}>{tree.name ?? 'unknown'}</span>
      </summary>

      <ul>
        <li>
          <a href={tree.page_url} class={'font-medium'}>
            Показать все
          </a>
        </li>
        {tree.children?.map((v) => {
          return getDetail(v)
        })}
      </ul>
    </details>
  )
}
